import React from 'react';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import StaticPage from '../StaticPage/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import JotformEmbed from 'react-jotform-embed';

import contactImage from './contact.jpg';
import contact1Image from './contact1.jpeg';

import css from './ContactPage.module.css';

const ContactPage = () => {
  return (
    <StaticPage
      title="Contact Us"
      description="Contact us with any questions, comments, or concerns on our convenient contact page. Our customer service team is always here to assist you and provide the support you need"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: 'Contact Tutulist',
        name: 'Contact page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Contact</h1>
          <div className={css.contactContentWrapper}>
            <div className={css.jotform}>
              <div className={css.leftImg}>
                <img className={css.coverImage} src={contactImage} alt="Tutulist" />
              </div>
              <div className={css.leftDetails}>
                <JotformEmbed src="https://form.jotformeu.com/230606229078153" />
              </div>
            </div>
            <div className={css.jotform}>
              <div className={css.email}>
                <div className={css.emailUs}>Email Us</div>
                <p>For order or technical support: hello@tutulist.com</p>
                <p>For media inquiries: media@tutulist.com</p>
              </div>
              <div className={css.leftImg}>
                <img className={css.coverImage2} src={contact1Image} alt="Tutulist" />
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default ContactPage;
